import { $$ } from '../../../shared/js/utils/dom';
import { Player } from '../../../shared/js/modules/player/player';

const players = $$('.player');
const playerInstances = [];
const initPlayer = el => {
  const playerInstance = new Player({
    player: el,
    config: {
      responsive: true,
    },
  });

  playerInstance.init();
  playerInstances.push(playerInstance);
};

players.forEach(player => {
  if (player.dataset.cookieBlockYoutube || player.dataset.cookieBlockVimeo)
    return;
  initPlayer(player);
});

export { initPlayer };
